// src/stone/icons/PhoneChat2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PhoneChat2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16.667 2.667A2.333 2.333 0 0 0 14.333 5v15.049l5.431-2.716H35A2.333 2.333 0 0 0 37.334 15V5A2.333 2.333 0 0 0 35 2.667zm-3.064-.731a4.33 4.33 0 0 1 3.064-1.27H35A4.333 4.333 0 0 1 39.334 5v10A4.333 4.333 0 0 1 35 19.333H20.236l-7.902 3.952V5c0-1.15.456-2.252 1.269-3.064M12.5 34.074a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" }),
      /* @__PURE__ */ jsx("path", { d: "M1.757 5.321C2.472 4.497 3.474 4 4.556 4h4.777v2H4.556c-.451 0-.918.206-1.287.631-.373.43-.602 1.04-.602 1.702V35c0 .661.229 1.272.602 1.702.369.426.836.631 1.287.631h15.889c.45 0 .918-.205 1.287-.63.372-.431.601-1.042.601-1.703V22.333h2V35c0 1.107-.38 2.192-1.09 3.012-.715.825-1.717 1.321-2.798 1.321H4.555c-1.08 0-2.083-.496-2.798-1.321-.71-.82-1.09-1.905-1.09-3.012V8.333c0-1.106.38-2.192 1.09-3.012" })
    ]
  }
);
var PhoneChat2X_default = PhoneChat2X;

export {
  PhoneChat2X,
  PhoneChat2X_default
};
